export interface Category {
  id: string;
  name: string;
  en: string;
  description: string;
  image: string;
  count: number;
}

export const categories: Category[] = [
  {
    id: 'drama',
    name: '剧情',
    en: 'Drama',
    description: '聚焦人性与命运的深描，短小篇幅里见众生百态。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20moody%20close-up%20of%20a%20thoughtful%20figure%20in%20soft%20window%20light%2C%20deep%20crimson%20and%20charcoal%20tones%2C%20dramatic%20shadow%2C%20film%20grain%20texture%2C%20mature%20drama%20aesthetic%2C%20high%20detail%2C%20no%20text&width=600&height=400&seq=cat-drama-01&orientation=landscape',
    count: 128,
  },
  {
    id: 'romance',
    name: '爱情',
    en: 'Romance',
    description: '成年人的情感博弈，克制而炽热的浪漫叙事。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20intimate%20scene%20of%20two%20elegant%20figures%20almost%20touching%20hands%20in%20warm%20candlelight%2C%20burgundy%20and%20dark%20tones%2C%20soft%20bokeh%2C%20film%20grain%2C%20mature%20romance%20aesthetic%2C%20high%20detail%2C%20no%20text&width=600&height=400&seq=cat-romance-01&orientation=landscape',
    count: 96,
  },
  {
    id: 'suspense',
    name: '悬疑',
    en: 'Suspense',
    description: '层层反转的谜题，短剧节奏里的心理惊悚。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20eerie%20corridor%20with%20a%20lone%20figure%20silhouette%20and%20dramatic%20red%20light%20from%20a%20doorway%2C%20dark%20charcoal%20tones%2C%20fog%2C%20film%20grain%2C%20mystery%20aesthetic%2C%20high%20detail%2C%20no%20text&width=600&height=400&seq=cat-suspense-01&orientation=landscape',
    count: 74,
  },
  {
    id: 'comedy',
    name: '喜剧',
    en: 'Comedy',
    description: '都市荒诞与机智对白，轻快节奏的成人幽默。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20stylish%20urban%20scene%20of%20a%20confident%20figure%20laughing%20in%20a%20retro%20bar%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20soft%20neon%20glow%2C%20film%20grain%2C%20high%20detail%2C%20no%20text&width=600&height=400&seq=cat-comedy-01&orientation=landscape',
    count: 58,
  },
  {
    id: 'urban',
    name: '都市',
    en: 'Urban',
    description: '摩天楼下的爱恨与野心，写实又锋利的都市切片。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20night%20cityscape%20of%20glowing%20skyscrapers%20seen%20through%20rain-covered%20glass%2C%20charcoal%20and%20crimson%20reflections%2C%20film%20grain%2C%20urban%20noir%20aesthetic%2C%20high%20detail%2C%20no%20text&width=600&height=400&seq=cat-urban-01&orientation=landscape',
    count: 110,
  },
  {
    id: 'crime',
    name: '犯罪',
    en: 'Crime',
    description: '灰色地带的较量，冷静克制的高压犯罪短剧。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20shadowy%20alley%20with%20a%20lone%20figure%20in%20a%20long%20coat%20under%20a%20flickering%20red%20lamp%2C%20dark%20charcoal%20tones%2C%20mist%2C%20film%20grain%2C%20crime%20noir%20aesthetic%2C%20high%20detail%2C%20no%20text&width=600&height=400&seq=cat-crime-01&orientation=landscape',
    count: 63,
  },
];